<ion-grid class="nav-settings-page">
  <ion-row>
    <ion-col size="12">
      <ion-card>
        <ion-card-header>
          <ion-card-title>NAV adatkapcsolat beállítása</ion-card-title>
          <ion-card-subtitle>
            A számlák automatikus NAV Online Számla beküldéséhez használt technikai felhasználók.
          </ion-card-subtitle>
        </ion-card-header>

        <ion-card-content *ngIf="!loading; else loadingState">
          <ion-item lines="full" class="mode-toggle">
            <ion-label>
              <h2>NAV beküldés bekapcsolva</h2>
              <p>
                Kikapcsolva a rendszer egyetlen számlát/storno/módosító bizonylatot sem küld be a NAV-nak
                (a cashbook beküldés ettől függetlenül működik, külön kapcsolóval).
              </p>
            </ion-label>
            <ion-toggle slot="end" [(ngModel)]="navdata.nav_enabled"></ion-toggle>
          </ion-item>
          <ion-item lines="full" class="mode-toggle">
            <ion-label>
              <h2>NAV tesztrendszer használata</h2>
              <p>
                Bekapcsolva a rendszer a NAV teszt API-ra küld. Kikapcsolva az éles NAV Online Számla API-t használja.
              </p>
            </ion-label>
            <ion-toggle slot="end" [(ngModel)]="navdata.sandbox_enabled"></ion-toggle>
          </ion-item>

          <ion-grid>
            <ion-row>
              <ion-col size="12" sizeLg="6">
                <section class="settings-section">
                  <h3>Teszt technikai felhasználó</h3>
                  <p class="section-help">Ezt használja a rendszer, ha a NAV tesztrendszer kapcsoló aktív.</p>

                  <ion-input label="Felhasználónév" label-placement="stacked" fill="outline" [(ngModel)]="navdata.test.login"></ion-input>
                  <ion-input label="Jelszó" label-placement="stacked" fill="outline" type="password" [(ngModel)]="navdata.test.password"></ion-input>
                  <ion-input label="Adószám" label-placement="stacked" fill="outline" [(ngModel)]="navdata.test.taxnumber"></ion-input>
                  <ion-input label="XML aláírókulcs" label-placement="stacked" fill="outline" [(ngModel)]="navdata.test.signkey"></ion-input>
                  <ion-input label="XML cserekulcs" label-placement="stacked" fill="outline" [(ngModel)]="navdata.test.exchangekey"></ion-input>
                </section>
              </ion-col>

              <ion-col size="12" sizeLg="6">
                <section class="settings-section">
                  <h3>Éles technikai felhasználó</h3>
                  <p class="section-help">Ezt használja a rendszer, ha a NAV tesztrendszer kapcsoló ki van kapcsolva.</p>

                  <ion-input label="Felhasználónév" label-placement="stacked" fill="outline" [(ngModel)]="navdata.live.login"></ion-input>
                  <ion-input label="Jelszó" label-placement="stacked" fill="outline" type="password" [(ngModel)]="navdata.live.password"></ion-input>
                  <ion-input label="Adószám" label-placement="stacked" fill="outline" [(ngModel)]="navdata.live.taxnumber"></ion-input>
                  <ion-input label="XML aláírókulcs" label-placement="stacked" fill="outline" [(ngModel)]="navdata.live.signkey"></ion-input>
                  <ion-input label="XML cserekulcs" label-placement="stacked" fill="outline" [(ngModel)]="navdata.live.exchangekey"></ion-input>
                </section>
              </ion-col>

              <ion-col size="12">
                <section class="settings-section software-section">
                  <h3>Szoftver adatok</h3>
                  <p class="section-help">Ezeket a NAV kérések szoftver azonosító blokkjában küldjük.</p>

                  <ion-grid>
                    <ion-row>
                      <ion-col size="12" sizeMd="6">
                        <ion-input label="Szoftver ID" label-placement="stacked" fill="outline" [(ngModel)]="navdata.software.softwareId"></ion-input>
                      </ion-col>
                      <ion-col size="12" sizeMd="6">
                        <ion-input label="Szoftver név" label-placement="stacked" fill="outline" [(ngModel)]="navdata.software.softwareName"></ion-input>
                      </ion-col>
                      <ion-col size="12" sizeMd="6">
                        <ion-input label="Működési mód" label-placement="stacked" fill="outline" [(ngModel)]="navdata.software.softwareOperation"></ion-input>
                      </ion-col>
                      <ion-col size="12" sizeMd="6">
                        <ion-input label="Főverzió" label-placement="stacked" fill="outline" [(ngModel)]="navdata.software.softwareMainVersion"></ion-input>
                      </ion-col>
                      <ion-col size="12" sizeMd="6">
                        <ion-input label="Fejlesztő neve" label-placement="stacked" fill="outline" [(ngModel)]="navdata.software.softwareDevName"></ion-input>
                      </ion-col>
                      <ion-col size="12" sizeMd="6">
                        <ion-input label="Fejlesztő email" label-placement="stacked" fill="outline" [(ngModel)]="navdata.software.softwareDevContact"></ion-input>
                      </ion-col>
                      <ion-col size="12" sizeMd="6">
                        <ion-input label="Fejlesztő országkód" label-placement="stacked" fill="outline" [(ngModel)]="navdata.software.softwareDevCountryCode"></ion-input>
                      </ion-col>
                      <ion-col size="12" sizeMd="6">
                        <ion-input label="Fejlesztő adószám" label-placement="stacked" fill="outline" [(ngModel)]="navdata.software.softwareDevTaxNumber"></ion-input>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </section>
              </ion-col>

              <ion-col size="12" class="actions">
                <ion-button color="primary" [disabled]="saving" (click)="saveNav()">
                  <ion-icon slot="start" name="save"></ion-icon>
                  {{ saving ? 'Mentés...' : 'Mentés' }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>

<ng-template #loadingState>
  <ion-card-content>
    <ion-spinner name="crescent"></ion-spinner>
    <span class="loading-text">NAV beállítások betöltése...</span>
  </ion-card-content>
</ng-template>
